import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export interface UiIconTab {
  id: string;
  label: string;
  /** URL de icono SVG/PNG (opcional) */
  iconSrc?: string | null;
}

export type UiIconTabBarAppearance = 'default' | 'icons';

/**
 * Átomo: barra de tabs con icono + label.
 * El tab activo se marca con línea inferior en color primario.
 * `appearance="icons"` oculta el label y deja solo el icono.
 * Sin lógica de negocio; solo estado de selección comunicado por output.
 */
@Component({
  selector: 'ui-icon-tab-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './icon-tab-bar.component.html',
  styleUrl: './icon-tab-bar.component.scss',
  host: {
    class: 'ui-icon-tab-bar-host',
    '[class.ui-icon-tab-bar-host--icons]': 'appearance() === "icons"',
  },
})
export class UiIconTabBarComponent {
  readonly tabs = input<readonly UiIconTab[]>([]);
  readonly activeTab = input<string>('');
  readonly appearance = input<UiIconTabBarAppearance>('default');

  readonly tabChange = output<string>();

  protected select(id: string): void {
    this.tabChange.emit(id);
  }

  protected isActive(id: string): boolean {
    return this.activeTab() === id;
  }

  protected iconMask(src: string): string {
    return `url("${src}")`;
  }
}
